import { Component } from '@angular/core'

import { BaseComponent } from '../../shared'

interface AutoAccidentReportDashboardKpi {
    totalReports: number
    reportsThisMonth: number
    reportsLast30Days: number
    dotAccidents: number
    reportsWithInjuries: number
    policeInvolvedCount: number
}

interface MonthlyCount {
    label: string
    count: number
}

interface DotSplit {
    dotCount: number
    nonDotCount: number
    unspecifiedCount: number
}

interface DepartmentCount {
    department: string
    count: number
}

interface AutoAccidentReportDashboardMetrics {
    kpi: AutoAccidentReportDashboardKpi
    monthlyCounts: MonthlyCount[]
    dotSplit: DotSplit
    topDepartments: DepartmentCount[]
}

const emptyMetrics = (): AutoAccidentReportDashboardMetrics => ({
    kpi: {
        totalReports: 0,
        reportsThisMonth: 0,
        reportsLast30Days: 0,
        dotAccidents: 0,
        reportsWithInjuries: 0,
        policeInvolvedCount: 0,
    },
    monthlyCounts: [],
    dotSplit: { dotCount: 0, nonDotCount: 0, unspecifiedCount: 0 },
    topDepartments: [],
})

@Component({
    selector: 'app-auto-accident-report-dashboard',
    templateUrl: './auto-accident-report-dashboard.component.html',
    styleUrls: ['./auto-accident-report-dashboard.component.css'],
    standalone: true,
})
export class AutoAccidentReportDashboardComponent extends BaseComponent {
    metrics: AutoAccidentReportDashboardMetrics = emptyMetrics()
    metricsLoadError = false

    constructor() {
        super()
        this.refresh()
    }

    refresh() {
        this.cancelableRequest(
            'autoAccidentReportDashboard',
            true,
            this.services.data.get<AutoAccidentReportDashboardMetrics>('/api/AutoAccidentReport/GetDashboardMetrics').subscribe({
                next: result => {
                    this.metrics = result ?? emptyMetrics()
                    this.metricsLoadError = false
                    this.initialLoadingComplete()
                },
                error: () => {
                    this.metrics = emptyMetrics()
                    this.metricsLoadError = true
                    this.initialLoadingComplete()
                },
            }),
        )
    }

    maxMonthlyCount(): number {
        return Math.max(...this.metrics.monthlyCounts.map(m => m.count), 1)
    }

    dotTotal(): number {
        return this.metrics.dotSplit.dotCount + this.metrics.dotSplit.nonDotCount + this.metrics.dotSplit.unspecifiedCount
    }
}
